var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-form-container",attrs:{"id":"card-form-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }